import { createRouter, createWebHistory } from 'vue-router'

import Index from '../components/Index.vue';

const router = createRouter({
  history: createWebHistory(),
  mode: 'history',
  base: '/',
  routes: [
      { path: '/konfigurator', name: 'konfigurator', component: Index },
      { path: '/hausnotruf', name: 'hausnotruf', component: Index },
      { path: '/', name: 'default', component: Index }, // For local setup,
      { path: '/vue-3/demo/' + BRAND_THEME, name: 'demo', component: Index }, // For live demo setup
      { path: '/vue-3/' + BRAND_THEME, name: 'live', component: Index }, // For live white labels setup
      { path: '/vue-3/landingpage/', name: 'live-landingpage', component: Index } // For live landing page setup
  ]
})

export default router
